/**
 * Created by andrey on 26.12.2020.
 */

const EditorFogBlock = function (...args) {
    FogBlock.apply(this, args);

    this.onGetView = function () {};

    this.calcState();
};

EditorFogBlock.prototype = Object.create(FogBlock.prototype);
EditorFogBlock.prototype.constructor = EditorFogBlock;

EditorFogBlock.prototype.calcState = function () {
    this.setState(FogBlock.UNAVAILABLE);
};

EditorFogBlock.prototype.add = function (...args) {
    const tile = FogBlock.prototype.add.apply(this, args);

    if (tile && tile.isHead) {
        this.editorHead = new EditorFogHead(tile, this);
        tile.onUpdateState(this.state, true);
    }

    this.editorHead && this.editorHead.onUpdateTitle();

    return tile;
};

EditorFogBlock.prototype.setHead = function (position) {
    const oldHead = this.head;
    if (oldHead) {
        oldHead.isHead = false;
        delete this.head;
        delete this.editorHead;

        if (oldHead.view) {
            oldHead.view.removeHead();
        }
        oldHead.onUpdateState(this.state, true);
    }

    if (!position) {
        return;
    }

    const tile = this.findTile(position.x, position.y);
    if (!tile) {
        this.add(position.x, position.y, { head: true });
        return;
    }

    tile.isHead = true;
    this.head = tile;
    this.editorHead = new EditorFogHead(tile, this);

    tile.onUpdateState(this.state, true);
    this.editorHead.onUpdateTitle();
};

EditorFogBlock.prototype.rename = function (newId) {
    this.id = cleverapps.castType(newId);
    this.editorHead && this.editorHead.onUpdateTitle();
};

EditorFogBlock.prototype.remove = function (x, y) {
    const removeTile = this.findTile(x, y);
    if (!removeTile) {
        return;
    }
    removeTile.open();
    removeTile.animateOpen();

    this.tiles = this.tiles.filter((tile) => tile !== removeTile);

    if (this.balloonTile === removeTile) {
        delete this.balloonTile;
    }

    if (this.head === removeTile) {
        delete this.head;
        delete this.editorHead;
    }

    this.editorHead && this.editorHead.onUpdateTitle();
};
